import { apiRoutes } from '../../api-routes';
import { epApiUrl } from '../../constants';
import { type AxiosRequestConfig, httpClient } from '../../util';
import type { FindAdmin, FindAdminRequest } from './types';

export const findAdminFn = async (
  body: FindAdminRequest,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.post<FindAdmin[]>(
    epApiUrl + apiRoutes.place.findAdmin,
    { ...body },
    {
      ...config,
    }
  );

  return response.data;
};
